<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  name: 'ClyTimePicker',
  props: {
    width: {
      type: Number,
      default: 100,
      required: false,
    },
    format: {
      type: String,
      default: 'HH:mm',
      required: false,
    },
    clearable: {
      type: Boolean,
      default: false,
      required: false,
    },
    appendToBody: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
});
</script>
<template>
  <el-time-picker
    :append-to-body="appendToBody"
    :style="{'width': width + 'px'}"
    class="cly-vue-time-picker"
    v-bind="$attrs"
    :format="format"
    :clearable="clearable"
    v-on="$listeners"
  />
</template>
